import React from 'react';
import DashboardIndex from 'pages/dashboard';
import { RouteObject } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import Dashboard from 'pages/overview';
import CreateShopLayout from 'layouts/create-shop.layout';
import CreateShopIndex from 'pages/create-shop';
import CreateShopDetails from 'pages/create-shop/create-shop-details';
import CreateShopFees from 'pages/create-shop/create-shop-fees';
import CreateShopImages from 'pages/create-shop/create-shop-images';
import CreateShopPolygon from 'pages/create-shop/create-shop-polygon';
import CreateShopOpeningTime from 'pages/create-shop/create-shop-opening-time';
import CreateShopMetadata from 'pages/create-shop/create-shop-metadata';
import CreateShopPreview from 'pages/create-shop/create-shop-preview';

import CreateCokitchenLayout from 'layouts/create-cokitchen.layout';
import CreateCokitchen from 'pages/create-cokitchen';
import CreateCokitchenKitchen from 'pages/create-cokitchen/create-cokitchen-kitchen';
import CreateCokitchenPolygon from 'pages/create-cokitchen/create-cokitchen-polygon';
import CreateCokitchenExpore from 'pages/create-cokitchen/create-cokitchen-explore';
import CreateCokitchenBrands from 'pages/create-cokitchen/create-cokitchen-brands';
import CokitchenPreview from 'pages/create-cokitchen/create-cokitchen-preview';
import ItemsIndex from 'pages/items';
import CategoryItems from 'pages/items/item-category-items-page';
import UploadXlsMeals from 'pages/new-meal-xls/upload-meals';
import NewMealXlsIndex from 'pages/new-meal-xls';
import ReviewShopMeal from 'pages/new-meal-xls/review-shop-meal';
import NewMealXlsLayout from 'layouts/new-meal-xls.layout';
import EditShopDetailsIndex from 'pages/edit-shop';
import ShopDetails from 'pages/edit-shop/shop-details';
import EditShopLayout from 'layouts/edit-shop.layout';
import ShopImages from 'pages/edit-shop/shop-images';
import ShopOpeningTime from 'pages/edit-shop/shop-opening-time';
import ShopPolygon from 'pages/edit-shop/shop-polygon';
import ShopMetadata from 'pages/edit-shop/shop-metadata';
import ShopFees from 'pages/edit-shop/shop-fees';

const NEW_ITEM_XLS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <NewMealXlsIndex />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_XLS_UPLOAD,
    element: <UploadXlsMeals />
  },

  {
    path: ROUTE_KEYS.NEW_SHOP_MEAL_XLS_REVIEW,
    element: <ReviewShopMeal />
  }
];
const CREATE_COKITCHEN_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateCokitchen />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_KITCHEN,
    element: <CreateCokitchenKitchen />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_POLYGON,
    element: <CreateCokitchenPolygon />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_EXPLORE,
    element: <CreateCokitchenExpore />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_BRANDS,
    element: <CreateCokitchenBrands />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_PREVIEW,
    element: <CokitchenPreview />
  }
];
const SHOP_FORM_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateShopIndex />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_DETAILS,
    element: <CreateShopDetails />
  },

  {
    path: ROUTE_KEYS.SHOP_FORM_IMAGES,
    element: <CreateShopImages />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_POLYGON,
    element: <CreateShopPolygon />
  },

  {
    path: ROUTE_KEYS.SHOP_FORM_OPENING_TIME,
    element: <CreateShopOpeningTime />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_METADATA,
    element: <CreateShopMetadata />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_FEES,
    element: <CreateShopFees />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_PREVIEW,
    element: <CreateShopPreview />
  }
];
const SHOP_DETAILS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <EditShopDetailsIndex />
  },
  {
    path: ROUTE_KEYS.SHOP_DETAILS_PAGE,
    element: <ShopDetails />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_IMAGES,
    element: <ShopImages />
  },
  {
    path: ROUTE_KEYS.SHOP_OPENING_TIME,
    element: <ShopOpeningTime />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_POLYGON,
    element: <ShopPolygon />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_METADATA,
    element: <ShopMetadata />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM_FEES,
    element: <ShopFees />
  }
];
export const SHOP_DASHBOARD_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <DashboardIndex />
  },
  {
    path: ROUTE_KEYS.OVERVIEW,
    element: <Dashboard />
  },
  {
    path: ROUTE_KEYS.SHOP_FORM,
    element: <CreateShopLayout />,
    children: SHOP_FORM_ROUTES
  },
  {
    path: ROUTE_KEYS.EDIT_SHOP_FORM,
    element: <EditShopLayout />,
    children: SHOP_DETAILS_ROUTES
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN,
    element: <CreateCokitchenLayout />,
    children: CREATE_COKITCHEN_ROUTES
  },
  {
    path: ROUTE_KEYS.ITEMS_BY_CATEGORY,
    element: <ItemsIndex />
  },
  {
    path: ROUTE_KEYS.CATEGORY_ITEMS,
    element: <CategoryItems />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_XLS,
    element: <NewMealXlsLayout />,
    children: NEW_ITEM_XLS_ROUTES
  }
];
